import { isAvailableBecauseCanEditFile } from '@/app/actions';
import { Action } from '@/app/actions/actions';
import type { ActionSpecRecord } from '@/app/actions/actionsSpec';
import { sheets } from '@/app/grid/controller/Sheets';
import { quadraticCore } from '@/app/web-workers/quadraticCore/quadraticCore';
import { FiltersIcon } from '@/shared/components/Icons';

const hasSheetAutoFilter = (): boolean => !!sheets.sheet.autoFilter;

/** Whether any column of the sheet AutoFilter has criteria applied. */
const hasSheetAutoFilterCriteria = (): boolean => !!sheets.sheet.autoFilter?.filtered_columns.length;

export const toggleSheetAutoFilter = () => {
  quadraticCore.toggleSheetAutoFilter(sheets.current, sheets.sheet.cursor.save(), false);
};

export const clearSheetAutoFilter = () => {
  if (!hasSheetAutoFilter()) return;
  quadraticCore.clearSheetAutoFilter(sheets.current, false);
};

export const reapplySheetAutoFilter = () => {
  if (!hasSheetAutoFilter()) return;
  quadraticCore.reapplySheetAutoFilter(sheets.current, false);
};

type SheetAutoFilterSpec = Pick<ActionSpecRecord, Action.Filter | Action.ClearFilter | Action.ReapplyFilter>;

export const sheetAutoFilterSpec: SheetAutoFilterSpec = {
  [Action.Filter]: {
    label: () => 'Filter',
    Icon: FiltersIcon,
    isAvailable: isAvailableBecauseCanEditFile,
    run: toggleSheetAutoFilter,
  },
  [Action.ClearFilter]: {
    label: () => 'Clear',
    labelVerbose: 'Clear Filter',
    Icon: FiltersIcon,
    isAvailable: (args) => isAvailableBecauseCanEditFile(args) && hasSheetAutoFilterCriteria(),
    run: clearSheetAutoFilter,
  },
  [Action.ReapplyFilter]: {
    label: () => 'Reapply',
    labelVerbose: 'Reapply Filter',
    Icon: FiltersIcon,
    isAvailable: (args) => isAvailableBecauseCanEditFile(args) && hasSheetAutoFilterCriteria(),
    run: reapplySheetAutoFilter,
  },
};
